import { render, staticRenderFns } from "./RowStandard.vue?vue&type=template&id=24f6e72d&scoped=true"
import script from "./RowStandard.vue?vue&type=script&lang=js"
export * from "./RowStandard.vue?vue&type=script&lang=js"
import style0 from "./RowStandard.vue?vue&type=style&index=0&id=24f6e72d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6e72d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f6e72d')) {
      api.createRecord('24f6e72d', component.options)
    } else {
      api.reload('24f6e72d', component.options)
    }
    module.hot.accept("./RowStandard.vue?vue&type=template&id=24f6e72d&scoped=true", function () {
      api.rerender('24f6e72d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/RowStandard.vue"
export default component.exports